import React from 'react';
import { Provider } from 'react-redux';
import {
    MuiThemeProvider,
    withStyles,
} from 'material-ui/styles';
import store from './store';
import appTheme from '../config/appTheme';
import globalStyles from '../config/globalStyles';
import AppToolbar from './layout/AppToolbar';
import PageWrapper from './layout/PageWrapper';
import FormStepperContainer from './FormStepper/FormStepperContainer';

function App() {
    return (
        <Provider store={store}>
            <MuiThemeProvider theme={appTheme}>
                <div>
                    <AppToolbar
                        title="SGL Fintech"
                    />
                    <PageWrapper>
                        <FormStepperContainer />
                    </PageWrapper>
                </div>
            </MuiThemeProvider>
        </Provider>
    );
}

export default withStyles(globalStyles)(App);



// WEBPACK FOOTER //
// ./src/app/App.js